import { useStorage } from '@vueuse/core';
import { toRef, watch, watchEffect } from 'vue';
import { log, toggle_dark_mode } from 'taxi-lib';
import { useTheme } from 'vuetify';

const prefs = useStorage(
    'prefs',
    {
        taxi_style: 'default',
        taxi_order: 'default',
        taxi_show: 'work_duty',
        zone_taxis_layout: '1:2',
        show_empty: true,
        font_scale: 1.25,
        zones_visible: true,
        nav_points_visible: true,
        view: 'zones',
        dark_mode: true,
        show_count: true,
    },
    localStorage,
    { mergeDefaults: true }
);

export function useThemePrefs() {
    const dark_mode = toRef(prefs.value, 'dark_mode');
    const theme = useTheme();
    const toggle_dark_mode_pref = () => {
        dark_mode.value = !dark_mode.value;
        log.d('dark_mode pref updated', dark_mode.value);
        toggle_dark_mode(theme);
    }
    return {
        dark_mode,
        toggle_dark_mode_pref,
    }
};

export function useFontPrefs() {
    const font_scale = toRef(prefs.value, 'font_scale');
    watchEffect(() => {
        const new_value = parseInt(16 * font_scale.value)
        document.documentElement.style.fontSize = `${new_value}px`
        log.d('font_scale', font_scale.value)
        log.d('document.documentElement.style.fontSize', document.documentElement.style.fontSize)
    })
    const update_font_scale = (new_scale) => {
        font_scale.value = new_scale;
    }
    return {
        font_scale,
        update_font_scale,
    }
};

export function useViewPrefs() {
    return {
        view: toRef(prefs.value, 'view'),
    }
};

export function useZonesPrefs() {
    return {
        show_empty: toRef(prefs.value, 'show_empty'),
        show_count: toRef(prefs.value, 'show_count'),
        zone_taxis_layout: toRef(prefs.value, 'zone_taxis_layout'),
    }
};

export function useTaxisPrefs() {
    return {
        taxi_order: toRef(prefs.value, 'taxi_order'),
        taxi_show: toRef(prefs.value, 'taxi_show'),
    }
};

export function useMapPrefs() {
    return {
        taxi_style: toRef(prefs.value, 'taxi_style'),
        nav_points_visible: toRef(prefs.value, 'nav_points_visible'),
        zones_visible: toRef(prefs.value, 'zones_visible'),
    }
};